import "../Tweets.css";

//react
import { useState, useEffect } from "react";

//components
import TweetGraph from "../../reusable/TweetGraph/TweetGraph";

//hooks
import { useCurrentLanguage } from "../../../hooks/useCurrentLanguage";

//utils
import { getCsvData } from "../../../utils/functions/getCsvData";

//assets
import TEXT from "../../../utils/text/prensa.json";

//functionss
import { formatTrimesterLabel } from "../../../utils/functions/formatTrimesterLabel";

export default function GenderRetorno({
  selectedCountry,
  countryName,
  countryOptions,
  setImg1,
  setImg2,
  setImg3,
  setImg4,
  setImg5,
  setImg6,
  //setImg7
}) {
  //language
  const { language } = useCurrentLanguage();

  //useState - data2_t
  const [data2_t, setData2_t] = useState([]);

  //useState - img url 1
  // const [imgUrl1, setImgUrl1] = useState("");
  // const [imgUrl2, setImgUrl2] = useState("");
  const [imgUrl3, setImgUrl3] = useState("");
  // const [imgUrl4, setImgUrl4] = useState("");
  // const [imgUrl5, setImgUrl5] = useState("");
  // const [imgUrl6, setImgUrl6] = useState("");
  // const [imgUrl7, setImgUrl7] = useState("");

  //useEffect
  useEffect(() => {
    processData2T();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCountry]);

  //useEffect - imgs
  useEffect(() => {
    // setImg1(imgUrl1)
    // setImg2(imgUrl2)
    setImg3(imgUrl3);
    // setImg4(imgUrl4)
    // setImg5(imgUrl5)
    // setImg6(imgUrl6)
    //setImg7(imgUrl7)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [imgUrl3]);

  const processData2T = async () => {
    // 1. Fetch the data
    let df1 = await getCsvData(`/data/retorno/genero_3m.csv`);

    let tempDates = [];
    let tempMap = {};

    // 2. Iterate, Sanitize, and Aggregate
    df1.forEach((row) => {
      // --- THE BOUNCER ---
      if (!row || !row.genero || !row.date) return;

      // Filter: If specific country selected, skip others.
      if (selectedCountry !== "NAC" && row.country !== selectedCountry) return;

      // Date Fix: "1/1/2017" -> "2017-01-01"
      let date = row.date;
      if (date.includes("/")) {
        const [day, month, year] = date.split("/");
        date = `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      }

      // Parse Value
      // NOTE: The old file had values like 96.0. The new file has 0.03.
      // If the graph looks too low (flat), change this to: parseFloat(row.genero) * 100;
      const val = parseFloat(row.genero);

      // Init Map Entry
      if (!tempMap[date]) {
        tempDates.push(date);
        tempMap[date] = { sum: 0, count: 0 };
      }

      // Accumulate
      tempMap[date].sum += val;
      tempMap[date].count += 1;
    });

    // 3. Flatten to Arrays
    let dates = [];
    let values = [];

    tempDates.forEach((date) => {
      // Format label using the legacy helper
      dates.push(formatTrimesterLabel(date));

      // Calculate True Average (Sum / Count)
      const d = tempMap[date];
      const avg = d.count > 0 ? d.sum / d.count : 0;

      // Push final value
      // Note: If you want percentages (3.4%) instead of ratios (0.034), multiply avg * 100 here.
      values.push(avg * 100);
    });

    let combinedArray = [dates, values];

    // 4. Config Graph
    let temp = [
      {
        id: "q_gender", // updated ID for safety
        question: TEXT["topics"]["graph1"]["title"][language], // Keeping legacy text ref
        data: combinedArray,
        rotate: false,
        graphType: "line",
        hasOptions: false,
        isPercentage: true,
        seriesName: language === "es" ? ["Género"] : ["Gender"], // Updated label to match context
        updateTotrimester: false,
      },
    ];

    setData2_t(temp);
  };

  return (
    <div className="surveys-page-content">
      <div className="surveys-page-graphs">
        <div className="survey-page-full-surveys">
          <div className="full-screen">
            <div className="nl-selector-container"></div>
            <div>
              {/* gender */}
              {data2_t.length > 0 && (
                <TweetGraph
                  data={data2_t}
                  title={TEXT["gender"]["gender_ret"]["title"][language]}
                  setImgUrl={setImgUrl3}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
